import React from "react";
import { Route, Switch } from "react-router-dom";

import { checkAuthentication } from "./checkAuthentication";

import ClientListPage from "../components/OrganizationList/ClientListPage";
import BalanceSheetPage from "../components/BalanceSheet/BalanceSheetPage";
import DashboardPage from "../components/Dashboard/DashboardPage";
import PresentationPage from "../components/Presentation/PresentationPage";
import EmbeddedPage from "../components/Dashboard/EmbeddedPage";
import DashboardCompositionPage from "../components/DashboardComposition/DashboardCompositionPage";
import DashboardListPage from "../components/DashboardList/DashboardListPage";
import SlideListPage from "../components/SlideList/SlideListPage";
import SlideCompositionPage from "../components/SlideComposition/SlideCompositionPage";
import CollaboratorSpacePage from "../components/CollaboratorSpace/CollaboratorSpacePage";
import { isClientAccess } from "../utils";
import NotFoundV2 from "../components/NotFound/NotFoundV2";
import AuthorizationsPage from "../components/Authorizations/AuthorizationsPage";
import EmbeddedBalanceSheetPage from "../components/BalanceSheet/EmbeddedBalanceSheetPage";
import AnnexeCategoriesPage from "../components/AnnexeCategories/AnnexeCategoriesPage";
import PreparePresentationPage from "../components/PreparePresentation/PreparePresentationPage";
import PresentationAccess from "../components/Presentation/PresentationAccess";
import IndicatorsExplanationPage from "../components/IndicatorsExplanation/IndicatorsExplanationPage";
import ExtraSlidesContentPage from "../components/ExtraSlides/ExtraSlidesContentPage";
import FicheClientPage from "../components/FicheClient/FicheClientPage";
import AnnexesPage from "../components/Annexes/AnnexesPage";
import CollaboratorListPage from "../components/Collaborator/CollaboratorListPage";
import AssociateDashbboardsPage from "../components/AssociateDashboards/AssociateDashboardsPage";
import HomePage from "../components/home/HomePage";

// const Home = connect(state => ({
//   currentOrganization: selectCurrentOrganization(state)
// }))(({ currentOrganization }) => {
//   return isClientAccess(currentOrganization) ? (
//     <Redirect to={`/fiche-client/${currentOrganization.uen}`} />
//   ) : (
//     <Redirect to={`/folders`} />
//   );
// });
export const urls = {
  index: "/",
  clients: "/folders/:id?",
  dashboards: "/dashboards",
  collaborators: "/collaborators",
  balanceSheet: "/balance-sheet/:uen?/:year?",
  dashboard: "/dashboard/:uen?/:year?",
  diaporama: "/diaporama/:uen",
  preparePresentation: "/prepare-presentation/:uen/:id?",
  embeddedDashboard: "/embed/dashboard/:uen/:id?",
  embeddedBalanceSheet: "/embed/balance-sheet/:uen",
  dashboardComposition: "/composition/dashboard/:id?",
  slideComposition: "/composition/slide/:id?",
  collaboratorSpace: "/collaborator-space/:id?/:year?",
  slides: "/slides",
  authorizations: "/authorizations",
  annexeCategories: "/annexe-categories",
  presentation: "/presentation/:uen",
  indicatorsExplanation: "/indicators-explanation",
  extraSlides: "/extra-slides",
  ficheClient: "/fiche-client/:uen?/:year?",
  annexes: "/annexes/:uen?/:year?",
  community: "/community/:communityUrl/:communityId",
  associateDashboards: "/associate-dashboards",
  notFound: "*"
};

export const getRoutes = (currentOrganization, backOffice, portail) => {
  const authorisation =
    currentOrganization && currentOrganization.authorisation;
  const loggedAs = authorisation && authorisation.role;

  let accessToSetting = currentOrganization
    ? currentOrganization.userType === "ADMIN" ||
      currentOrganization.userType === "ADMIN_SUPERVISOR" ||
      (!isClientAccess(currentOrganization, portail) && loggedAs === "MANAGER")
    : false;

  return (
    <Switch>
      {/*<Route exact path="/" component={checkAuthentication(Home)} />*/}
      <Route
        exact
        path="/"
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(HomePage)}
      />
      {!isClientAccess(currentOrganization, portail) ? (
        <Route
          path={urls.clients}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(ClientListPage)}
        />
      ) : (
        ""
      )}

      <Route
        path={urls.balanceSheet}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(BalanceSheetPage)}
      />
      <Route
        path={urls.dashboard}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(DashboardPage)}
      />
      <Route
        path={urls.diaporama}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(PresentationPage)}
      />
      <Route
        path={urls.collaboratorSpace}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(CollaboratorSpacePage)}
      />
      {!isClientAccess(currentOrganization, portail) ? (
        <Route
          path={urls.preparePresentation}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(PreparePresentationPage)}
        />
      ) : (
        ""
      )}

      <Route
        path={urls.ficheClient}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(FicheClientPage)}
      />

      <Route
        path={urls.annexes}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(AnnexesPage)}
      />

      <Route
        path={urls.embeddedDashboard}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(EmbeddedPage)}
      />
      <Route
        path={urls.embeddedBalanceSheet}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(EmbeddedBalanceSheetPage)}
      />

      {!isClientAccess(currentOrganization, portail) ? (
        <Route
          path={urls.collaborators}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorListPage)}
        />
      ) : (
        ""
      )}

      {accessToSetting ? (
        <Route
          path={urls.annexeCategories}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(AnnexeCategoriesPage)}
        />
      ) : (
        ""
      )}

      {accessToSetting ? (
        <Route
          path={urls.associateDashboards}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(AssociateDashbboardsPage)}
        />
      ) : (
        ""
      )}

      {accessToSetting ? (
        <Route
          path={urls.authorizations}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(AuthorizationsPage)}
        />
      ) : (
        ""
      )}

      {accessToSetting ? (
        <Route
          path={urls.indicatorsExplanation}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(IndicatorsExplanationPage)}
        />
      ) : (
        ""
      )}

      {accessToSetting ? (
        <Route
          path={urls.extraSlides}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(ExtraSlidesContentPage)}
        />
      ) : (
        ""
      )}
      <Route
        path={urls.presentation}
        onUpdate={() => window.scrollTo(0, 0)}
        component={PresentationAccess}
      />

      {/*  <Route
        path={urls.community}
        onUpdate={() => window.scrollTo(0, 0)}
        component={communityRedirection}
      />*/}

      {!isClientAccess(currentOrganization, portail) || backOffice ? (
        <div>
          <Route
            path={urls.dashboardComposition}
            onUpdate={() => window.scrollTo(0, 0)}
            component={checkAuthentication(DashboardCompositionPage)}
          />
          <Route
            path={urls.dashboards}
            onUpdate={() => window.scrollTo(0, 0)}
            component={checkAuthentication(DashboardListPage)}
          />

          <Route
            path={urls.slides}
            onUpdate={() => window.scrollTo(0, 0)}
            component={checkAuthentication(SlideListPage)}
          />

          <Route
            path={urls.slideComposition}
            onUpdate={() => window.scrollTo(0, 0)}
            component={checkAuthentication(SlideCompositionPage)}
          />
          <Route
            exact
            path="/"
            onUpdate={() => window.scrollTo(0, 0)}
            component={checkAuthentication(HomePage)}
          />
        </div>
      ) : (
        ""
      )}
      <Route
        path="*"
        component={() => <NotFoundV2 errorPageType={"ERROR_404"} />}
      />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/router/getRoutes.js